/* eslint-disable no-multi-assign */ // ok in reducers
import { createCombinedReducer } from 'util/reducers'

import hasErrored from './hasErrored'
import isLoading from './isLoading'
import isLoaded from './isLoaded'

export default createCombinedReducer({
  hasErrored,
  isLoaded,
  isLoading,
})
